import type { JSX } from 'react';
import { ServiceOrganizationRole as Role, ServiceCode } from '@common/enums';
import { BariatricsHospitalSettings } from './bariatrics/BariatricsHospitalSettings';

type ServiceOrganizationRoleComponentProps = {
    role: Role;
    serviceCode: ServiceCode;
};

type ServiceOrganizationRoleComponents = { [key in Role]?: () => JSX.Element };

const serviceOrganizationRoleComponents: { [key in ServiceCode]?: ServiceOrganizationRoleComponents } = {
    [ServiceCode.BariPre]: {
        [Role.hospital]: BariatricsHospitalSettings,
    },
    [ServiceCode.BariPost]: {
        [Role.hospital]: BariatricsHospitalSettings,
    },
};

export function ServiceOrganizationRole(props: ServiceOrganizationRoleComponentProps): JSX.Element | null {
    const Component = serviceOrganizationRoleComponents[props.serviceCode]?.[props.role];

    if (!Component) {
        return null;
    }

    return <Component />;
}
